// This file is automatically generated. Do not edit it directly.
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

interface ViteImportMetaEnv {
  VITE_SUPABASE_URL?: string;
  VITE_SUPABASE_ANON_KEY?: string; // canonical
  // Deprecated: kept for backward compatibility; will be removed.
  VITE_SUPABASE_PUBLISHABLE_KEY?: string;
}

// حراسة: بعض البيئات (اختبارات/أدوات) قد لا تدعم import.meta
let env: ViteImportMetaEnv = {};
try {
  // فحص وجود import.meta.env في بيئات Vite فقط
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta && import.meta.env) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    env = import.meta.env as ViteImportMetaEnv;
  }
} catch {
  env = {};
}

const url = env.VITE_SUPABASE_URL;
let anon = env.VITE_SUPABASE_ANON_KEY || env.VITE_SUPABASE_PUBLISHABLE_KEY;
if (env.VITE_SUPABASE_ANON_KEY && env.VITE_SUPABASE_PUBLISHABLE_KEY && env.VITE_SUPABASE_ANON_KEY !== env.VITE_SUPABASE_PUBLISHABLE_KEY) {
  console.warn('[supabase] Detected different values for VITE_SUPABASE_ANON_KEY and deprecated VITE_SUPABASE_PUBLISHABLE_KEY. Using VITE_SUPABASE_ANON_KEY.');
  anon = env.VITE_SUPABASE_ANON_KEY; // prefer canonical
}

export const isSupabaseConfigured = Boolean(url && anon);

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(url!, anon!, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;

// Test override: if global __TEST_SUPABASE__ is set (by tests) prefer it
export const getSupabase = (): SupabaseClient | null => {
  const override = (globalThis as unknown as { __TEST_SUPABASE__?: SupabaseClient | null }).__TEST_SUPABASE__;
  return (override ?? supabase) as SupabaseClient | null;
};

export function setTestSupabase(client: SupabaseClient | null) {
  (globalThis as unknown as { __TEST_SUPABASE__?: SupabaseClient | null }).__TEST_SUPABASE__ = client;
}

export async function restHealthCheck(resource: 'pages' | 'sectors' = 'pages') {
  if (!isSupabaseConfigured || !url || !anon) {
    return { ok: false, status: 0, reason: 'ENV_MISSING' as const };
  }
  try {
    const endpoint = `${url}/rest/v1/${resource}?select=slug&limit=1`;
    const res = await fetch(endpoint, {
      headers: { apikey: anon, Authorization: `Bearer ${anon}` },
    });
    return { ok: res.ok, status: res.status, reason: res.ok ? 'OK' as const : 'HTTP_ERROR' as const };
  } catch {
    return { ok: false, status: -1, reason: 'NETWORK' as const };
  }
}